import React, { useState } from 'react';
import { Col, Row } from 'antd';
import '@ant-design/compatible/assets/index.css';
import { testEmpty, formatMoney } from '@iso/lib/helpers/utility';
import { testNumber } from '../scripts/utils';
import MoneyInput from '@iso/components/MoneyInput.js';

export default function AcrescimoDescontoVenda(props) {

    const [order, setOrder] = useState({})

    React.useEffect(() => {

        console.log('props.currentOrder: ', props.currentOrder);

        let aux = {...props.currentOrder};

        setOrder(aux);
    }, [])

    const onChangeVal = (f, v) => {
        setOrder(prev => {

            prev[f] = v;

            if(typeof prev.discount !== 'undefined')
                prev.discount = testNumber(prev.discount)
            if(typeof prev.addition !== 'undefined')
                prev.addition = testNumber(prev.addition)

            prev.amount = prev.subtotal - testNumber(prev.discount) + testNumber(prev.addition);

            props.onChange('order', prev);
            return prev;
        })
    }

    return (
        <Row gutter={24} className='contentItemEditInputs'>
            <Col span={12}>Sub total:</Col>
            <Col span={12}>
                <MoneyInput
                    name="subtotal"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(order.subtotal)}
                    disabled
                />
            </Col>
            <Col span={12}>Desconto:</Col>
            <Col span={12}>
                <MoneyInput
                    name="discount"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(order.discount, ''))}
                    onChange={(e) => onChangeVal('discount', e.target.value ) }
                />
            </Col>
            <Col span={12}>Acréscimo:</Col>
            <Col span={12}>
                <MoneyInput
                    name="addition"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(order.addition, ''))}
                    onChange={(e) => onChangeVal('addition', e.target.value ) }
                />
            </Col>
            <Col span={12}>Total líquido:</Col>
            <Col span={12}>
                <MoneyInput
                    name="amount"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(order.amount)}
                    disabled
                />
            </Col>
        </Row>
    )
}